import { ServiceError } from "./service-error";
export interface GetTimesZoneResponse {
	getTimesZoneResult: GetTimesZoneResult;
}

export interface GetTimesZoneResult {
	reason?: string; //6 para gremio no citable
	reasonDescription?: string;
	codError?: string;
	typeError?: string;
	Error?: string;
	timezoneInfo: Timeszone[];
	auditoryInfo: AuditoryInfo;
}

interface AuditoryInfo {
	originCall: string;
	transactionId: string;
}

export interface Timeszone {
	endDate: string;
	startDate: string;
}
